import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#how-it-works') {
      const el = document.getElementById('how-it-works');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      alert('Thank you for subscribing! We\'ll keep you updated on the agricultural revolution.');
      setEmail('');
    }
  };

  return (
    <>
      <section className="hero">
        <div className="hero-content">
          <h1>Bring Fresh Growth To Agriculture.</h1>
          <p>A platform that is revolutionizing agriculture, connecting farmers with AI-powered risk assessment, input financing through suppliers, and investment from funders—getting you up to speed with premium agri-tech solutions.</p>
          <Link to="/marketplace" className="btn btn-primary">Get Started</Link>
        </div>
        <div className="hero-video-section">
          <video
            className="hero-video"
            src="https://st60307.ispot.cc/agroinvezt_storage/ago_vid.mp4"
            controls
            muted
            loop
            playsInline
          />
          <div className="hero-video-text">
            <p>See how we're transforming agriculture with technology, connecting farmers to the resources they need for sustainable growth.</p>
          </div>
        </div>
        <div className="hero-image-block">
          <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80" alt="Lush green agricultural landscape" />
          <div className="hero-image-overlay">The Journey to a Perfection.</div>
        </div>
      </section>

      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-number">50+</div>
            <div className="stat-label">Years of Experience</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">200+</div>
            <div className="stat-label">Farms In Progress</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">120,000+</div>
            <div className="stat-label">Farmers Around World</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">$15B</div>
            <div className="stat-label">Agriculture Product</div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="content-block">
          <div className="content-tags">
            <span className="tag">2025</span>
            <span className="tag">Organic farm</span>
            <span className="tag">Automation farm</span>
            <span className="tag">Bio-medical farm</span>
            <span className="tag">Harvesting Legacy</span>
            <span className="tag">Planting Tomorrow</span>
          </div>
          <h3>Despite Advances In Agri-Tech, Traditional Labor-Intensive Farming Highlights Ongoing Inefficiencies.</h3>
          <p>AGRO-INVEST bridges this gap by leveraging AI risk scoring, digital vouchers, and investor capital to modernize agricultural financing—empowering farmers with the inputs they need while offering transparent investment opportunities.</p>
        </div>
      </section>

      <section className="section">
        <div className="banner-overlay">
          <img src="https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=1200&q=80" alt="Aerial view of green agricultural fields" />
          <span className="orange-dot"></span>
          <div className="banner-overlay-content">
            <h2>Cultivate And Learn From Industry Experts And Enthusiasts</h2>
          </div>
        </div>
      </section>

      <section className="section" id="how-it-works">
        <div className="section-header">
          <h2>Next-Gen Solutions For Optimal Crop Growth</h2>
          <p>Our platform combines precision farming, surveillance technology, and automated processes to transform agricultural investment. <Link to="/how-it-works">Learn how it works →</Link></p>
        </div>
        <div className="cards-grid">
          <div className="card">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80" alt="Farming Precision" className="card-image" />
            <div className="card-body">
              <h3>Farming Precision</h3>
              <p>AI-powered risk scoring and yield prediction for data-driven financing decisions.</p>
            </div>
          </div>
          <div className="card">
            <img src="https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=600&q=80" alt="Crop Surveillance" className="card-image" />
            <div className="card-body">
              <h3>Crop Surveillance</h3>
              <p>Farm verification through GPS, images, and structured data collection via WhatsApp.</p>
            </div>
          </div>
          <div className="card">
            <img src="https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=600&q=80" alt="Automated Farming" className="card-image" />
            <div className="card-body">
              <h3>Automated Farming</h3>
              <p>Digital voucher system for inputs, supplier verification, and seamless redemption tracking.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="banner-overlay">
          <img src="https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1200&q=80" alt="Sustainable farming" />
          <div className="banner-overlay-content">
            <h2>Changing The Game In Farming With Sustainable Practices And Cool Technologies, Shaping The Future Of Agriculture.</h2>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80" alt="Agricultural field" />
        <div className="cta-overlay"></div>
        <div className="cta-content">
          <h2>Join the Agricultural Revolution Today!</h2>
          <form className="cta-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="btn btn-green">Subscribe</button>
          </form>
        </div>
      </section>
    </>
  );
}

export default Home;
